import { type ScaledSize } from "react-native";

const smMaxWidth = 480;
const mdMaxWidth = 768;
const lgMaxWidth = 962;
const xlMaxWidth = 1280;

export const mediaQueryTests = {
  $base: () => true,

  $sm: (dimensions: ScaledSize) => dimensions.width <= smMaxWidth,
  $gtSm: (dimensions: ScaledSize) => dimensions.width > smMaxWidth,

  $md: (dimensions: ScaledSize) => dimensions.width <= mdMaxWidth,
  $gtMd: (dimensions: ScaledSize) => dimensions.width > mdMaxWidth,

  $lg: (dimensions: ScaledSize) => dimensions.width <= lgMaxWidth,
  $gtLg: (dimensions: ScaledSize) => dimensions.width > lgMaxWidth,

  $xl: (dimensions: ScaledSize) => dimensions.width <= xlMaxWidth,
  $gtXl: (dimensions: ScaledSize) => dimensions.width > xlMaxWidth,
} as const;
